export function composeEvents(theirEvent, ourEvent) {
  return (event) => {
    theirEvent && theirEvent(event);

    if (!event.defaultPrevented && ourEvent) {
      ourEvent(event);
    }
  };
}
